export function generateSeoUrl(url?: string) {
	if (!url) return ''

	const canonical = url?.split('?')[0].split('#')[0] // remove  query params and fragment identifier
	return `${canonical}${canonical?.endsWith('/') ? '' : '/'}`.toLowerCase()
}
